import { combineReducers } from "redux";
import  { ForgotPasswordReducer, LoginReducer, ResetExpiryPasswordReducer, ResetPasswordReducer, UpdatePasswordReducer } from "../LoginState/LoginReducer";
import {  EditUserReducer, UserByIdReducer, UserReducer, UsersListReducer, UsersListWithOutPagination, ImpersonateUserReducer } from "../UserState/UserReducer";
import { ClientReducer, ClientsListReducer,EditClientReducer,
    ClientByIdReducer,
    ClientsListWithOutPagination} from "../ClientState/ClientReducer";
import {EditProjectReducer, ProjectReducer,ProjectsListReducer,ProjectByIdReducer, ProjectsByIdReducer, ProjectsListWithOutPagination} from "../ProjectState/ProjectReducer"
import {DownloadFileReducer, FileReducer, UploadFileReducer} from "../FileState/uploadFileReducer";
import { AddTimesheetReducer, TimeSheetByProjectIdReducer, TimeSheetByProjectIdReducerForUserPage ,EditTimesheetsReducer, GetTimesheetByIdReducer, TimesheetsActionReducer, GenerateInvoiceReducer, DownloadInvoiceReducer, DownloadTimeSheetReducer, TimesheetListReducer, TimesheetAppReducer, RejectedTimesheetsListReducer, ToBeInvoicedListReducer, DownloadFileByIdReducer, ToBeInvoicedTimesheetListByEmployeeAndProjectReducer } from "../TimeSheetState/TimeSheetReducer";
import { ProfileReducer, UpdateProfileUserReducer } from "../ProfileState/ProfileReducer";
import { DocumentUploadReducer, EmpStatusReducer, GetDocTypesReducer, GetEmpStatusReducer } from "../EmployeeStatusState/empStatusReducer";
import { BudgetReportReducer, GenerateReportReducer, ReportsReducer } from "../ReportsState/ReportsReducer";
import { AppConfigHoverReducer, AppConfigReducer } from "../AppconifgStage/AppconfigReducer";
import {DashboardListReducer, DashboardMonthlyHoursReducer, EmpDashboardListReducer} from "../DashboardState/dashBoardReducer";
import { InvoiceListReducer, InvoicePaymentDateReducer, ReGenerateInvoicePDFReducer, InvoiceHoursReducer, UpdateInvoiceReducer, InvoiceInfoById } from "../InvoiceState/InvoiceReducer";
import { BirthdayWishesReducer, EventListReducer, EventsNotificationsListReducer, WorkAnniversaryWishesReducer } from "../EventState/EventsReducer";
import { AddQuoteReducer, EditQuoteReducer, QuoteByIdReducer, QuotesListReducer } from "../QuotesState/QuotesReducer";
import { AdminPrefrenceByIdReducer, AdminPrefrenceEditReducer, AdminPrefrenceListReducer, AdminprefrencesReducer } from "../AdminPreferencesState/AdminPrefrencesReducer";
import { TimeOffRequestsReducer, ApproveTimeOffRequestReducer, GetTimeOffByIdReducer, UpdateTimeOffRequestReducer, CreateTimeOffRequestReducer } from "../TimeOffManagerState/TimeOffManagerReducer";
const rootReducer = combineReducers({
    LoginReducer,
    ProfileReducer,
    ForgotPasswordReducer,
    ResetPasswordReducer,
    UpdatePasswordReducer,
    UserReducer,
    UsersListReducer,
    UserByIdReducer,
    EditUserReducer,
    ClientReducer,
    ClientsListReducer,
    EditClientReducer,
    ClientByIdReducer,
    ProjectReducer,
    ProjectsListReducer,
    ProjectsByIdReducer,
    TimeSheetByProjectIdReducer,
    TimeSheetByProjectIdReducerForUserPage,
    AddTimesheetReducer,
    EditTimesheetsReducer,
    GetTimesheetByIdReducer,
    EditProjectReducer,
    ProjectByIdReducer,
    UploadFileReducer,
    UsersListWithOutPagination,
    ImpersonateUserReducer,
    ClientsListWithOutPagination,
    ResetExpiryPasswordReducer,
    TimesheetsActionReducer,
    FileReducer,
    EmpStatusReducer,
    GetEmpStatusReducer,
    // BackgroundImageReducer,
    ReportsReducer,
    DownloadFileReducer,
    ProjectsListWithOutPagination,
    GenerateReportReducer,
    BudgetReportReducer,
    GenerateInvoiceReducer,
    GetDocTypesReducer,
    DocumentUploadReducer,
    AppConfigReducer,
    AppConfigHoverReducer,
    DownloadInvoiceReducer,
    DashboardListReducer,
    DownloadTimeSheetReducer,
    UpdateProfileUserReducer,
    InvoiceListReducer,
    TimesheetListReducer,
    TimesheetAppReducer,
    ReGenerateInvoicePDFReducer,
    InvoicePaymentDateReducer,
    EmpDashboardListReducer,
    RejectedTimesheetsListReducer,
    ToBeInvoicedListReducer,
    EventListReducer,
    DashboardMonthlyHoursReducer,
    WorkAnniversaryWishesReducer,
    BirthdayWishesReducer,
    QuotesListReducer,
    AddQuoteReducer,
    QuoteByIdReducer,
    EditQuoteReducer, 
    InvoiceHoursReducer,
    EventsNotificationsListReducer,
    UpdateInvoiceReducer,
    DownloadFileByIdReducer,
    ToBeInvoicedTimesheetListByEmployeeAndProjectReducer,
    InvoiceInfoById,
    AdminprefrencesReducer,
    AdminPrefrenceListReducer,
    AdminPrefrenceByIdReducer,
    AdminPrefrenceEditReducer,
    TimeOffRequestsReducer,
    ApproveTimeOffRequestReducer,
    GetTimeOffByIdReducer,
    UpdateTimeOffRequestReducer,
    CreateTimeOffRequestReducer,
    });
const rootR = (state, action) => rootReducer(state, action);
export default rootR;
